import { render, staticRenderFns } from "./ResetDevice.vue?vue&type=template&id=ac1a3bb2&"
import script from "./ResetDevice.vue?vue&type=script&lang=js&"
export * from "./ResetDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'directives', {ClosePopup});
